<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from 'cn'
import { SelectLabel, type SelectLabelProps } from 'reka-ui'

import { selectClasses } from './variants'

const props = defineProps<SelectLabelProps & { class?: HTMLAttributes['class'] }>()
</script>

<template>
  <SelectLabel :class="cn(selectClasses.menuLabel, props.class)">
    <slot />
  </SelectLabel>
</template>
